import React, { Component } from 'react';

import { Helmet } from 'react-helmet';
import Footer from 'components/Footer';

import cn from 'classnames';
import styles from './Collections.scss';

import CollectionsItem from 'components/CollectionsItem';
import CollectionsPopup from 'components/CollectionsPopup';
import Modal from 'components/Modal';
import { connect } from 'react-redux';
import { setPopUp } from 'actions/environment';
import { loadCollections, createCollection } from 'actions/collections';

import nothingFound from 'assets/images/nothingfound@2x.png';
import iconSearch from 'assets/images/icons/icon-search-dark.svg';

import { pluralize } from 'utils';
import withValidTrafic from 'decorators/withValidTrafic';
import tracker from '../../services/tracker';
import { withTranslation } from 'react-i18next';

@withValidTrafic()
class Collections extends Component {

  constructor(props) {
    super(props);
    this.state = {
      newCollectionName: ''
    };
  }

  UNSAFE_componentWillMount() {
    this.props.loadCollections({
    });
  }

  setPopUp = () => {
    const { setPopUp } = this.props;
    tracker.sendEvent('Web_Current_Add_To_Collection');
    setPopUp(
      <CollectionsPopup />,
      {
        // className: styles.NewsPopup,
        closeStyleName: 'Default',
        contentStyleName: 'Default',
        closeIcon: 'default'
      }
    );
  }

  handleChange = (e) => {
    this.setState({
      newCollectionName: e.target.value
    });
  }

  handleAddCollectionClick = (e) => {
    e.preventDefault();
    tracker.sendEvent('Web_Current_Add_To_Collection');
    this.props.createCollection({
      name: this.state.newCollectionName
      // userUid: this.props.userUid,
    });
    this.props.setPopUp();
  }

  render() {
    const { className, collections, t } = this.props;

    return (
      <React.Fragment>
        <Helmet>
          <title>
            {t('components.collections.title')}
          </title>
        </Helmet>
        {
            collections ?
              <div>
                {Object.values(collections).length ? (
                  <div className={styles.CollectionsWrap}>
                    <div className={cn(styles.Collections, className)}>
                      <div className={styles.Container}>
                        <div className={styles.TitleBlock}>
                          <p className={styles.Title}>
                            {t('components.collections.myCollections')}
                            <span className={styles.CollectionsCount}>
                              {Object.values(collections).length} {pluralize(Object.values(collections).length, t('components.collections.collection1'), t('components.collections.collection2'), t('components.collections.collection3'))}
                            </span>
                          </p>
                          <div className={styles.CollectionsActions}>
                            <button className={cn(styles.CreateButton, 'button-primary', 'button-primary--lg')} onClick={this.setPopUp}>
                              {t('components.collections.create')}
                            </button>
                          </div>

                        </div>
                        <div className={styles.List}>
                          {
                            collections && Object.values(collections).map(
                              (collection) => (
                                <CollectionsItem {...collection} key={collection.referal} />
                              )
                            )
                          }
                        </div>
                      </div>
                    </div>
                    <Footer />
                  </div>
                ) : (
                  <div className={styles.CollectionsWrap}>
                    <div className={cn(styles.Collections, styles.NoCollections, className)}>
                      <div className={styles.Container}>
                        <div className={styles.TitleBlock}>
                          <p className={styles.Title}>
                            {t('components.collections.myCollections')}
                          </p>
                        </div>
                        <div className={styles.NotFoundBlock}>
                          <div className={styles.NotFoundMain}>
                            <p className={styles.NotFoundTitle}>
                              {t('components.collections.noCollections')}
                            </p>
                            <p className={styles.NotFoundText}>
                              {t('components.collections.share')}
                            </p>
                            <form onSubmit={this.handleAddCollectionClick} className={styles.CreateCollection}>
                              <input
                                type="text"
                                className={styles.CreateCollectionInput}
                                placeholder={t('components.collections.enterName')}
                                onChange={this.handleChange}
                              />
                              <input
                                type="submit"
                                className={cn(styles.CreateCollectionBtn, 'button-primary', 'button-primary--md')}
                                disabled={this.state.newCollectionName === ''}
                                value={t('components.collections.create')}
                              />
                            </form>
                          </div>
                          <div className={styles.NotFoundImage}>
                            <img src={nothingFound} alt="nothing found" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <Footer />
                  </div>
                )}
              </div> : (
                <div className={styles.Wireframe}>
                  <div className={styles.Container}>
                    <div className={styles.TitleBlock}>
                      <p className={styles.Title}>
                        {t('components.collections.myCollections')}
                      </p>
                    </div>
                    <div className={styles.WireframeLoaderWrap}>
                      <div className={styles.WireframeLoader} />
                    </div>
                  </div>
                </div>
              )
          }
      </React.Fragment>
    );
  }
}

export default connect(
  state => ({
    collections: state.collections.data,
    userUid: state.profile.hash
  }),
  { setPopUp, loadCollections, createCollection }
)(withTranslation()(Collections));



// WEBPACK FOOTER //
// ./src/components/Collections/Collections.js